<template>
  <div
    class="section__vdo"
    data-aos="zoom-in"
    data-aos-duration="1200"
    ref="imageRef"
  >
    <video
      class="portfolio-video"
      autoplay="autoplay"
      loop="loop"
      muted="true"
      playsinline="true"
      preload="auto"
    >
      <source src="/static/video/si-portfolio.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
  <div class="section__firework" :class="{ 'animate-to-top': isScrolled }">
    <img src="/static/images/content/about/icon/firework.png" alt="" />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";

const imageRef = ref();
const isScrolled = ref(false);
// const scrollOpacity = ref(true);

const onImageScroll = async () => {
  if (window.innerWidth < 1200) {
    isScrolled.value = false;
    return;
  }

  const scrollPosition = window.scrollY;
  isScrolled.value = scrollPosition > 100;

  const image = imageRef.value;
  if (!image) return;

  image.classList.toggle("small", scrollPosition > 100);
};


onMounted(() => {
  window.addEventListener("scroll", onImageScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", onImageScroll);
});
</script>


<style lang="scss" scoped>
@import "@/assets/scss/app";
.section__vdo {
  width: 100%;
  transition: transform 0.5s ease-in-out, width 0.5s ease-in-out,
    margin-left 0.5s ease-in-out;
  transform-origin: center;
  margin-left: auto;
  &.small {
    transform: scale(0.5);
    width: 60%;
    margin-left: auto;
    margin-top: 50px;
    transform-origin: right;
    @media (max-width: 1400px) {
      margin-top: 70px;
    }
  }
}

.portfolio-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  aspect-ratio: 4 / 1.82;
  border-radius: 20px;

  @include media-breakpoint-down(md) {
    aspect-ratio: auto;
  }

  @include media-breakpoint-down(sm) {
    aspect-ratio: 4 / 2;
  }
}

.section__firework {
  position: absolute;
  // height: 100%;
  // width: 100%;
  top: 0;
  left: 0;
  animation: diagonalBottomLeftToTopRight 1.2s linear forwards; /* ตั้งค่าการทำงาน */
  &.animate-to-top {
    animation: diagonalBottomLeftToTopRightModified 1.2s linear forwards;
  }

  img {
    @media (max-width: 1500px) {
      height: 200px;
    }
    @include media-breakpoint-down(lg) {
      height: 150px;
    }
    @include media-breakpoint-down(xs) {
      display: none;
    }
  }

  @include media-breakpoint-down(lg) {
    height: auto;
    width: auto;
  }
  @include media-breakpoint-down(xs) {
    display: none;
  }
}

@keyframes diagonalBottomLeftToTopRight {
  from {
    transform: translate(0%, 0%);
  }
  to {
    transform: translate(295%, -75%);
  }
}

@keyframes diagonalBottomLeftToTopRightModified {
  from {
    transform: translate(295%, -75%);
  }
  to {
    transform: translate(400%, -150%);
  }
}

@include media-breakpoint-down(md) {
  @keyframes diagonalBottomLeftToTopRight {
    from {
      transform: translate(0%, 0%);
    }
    to {
      transform: translate(185%, -75%);
    }
  }
}

</style>
